/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef } from 'react'

type Callable = (...args: any[]) => void
type DebauncedFunction = (...args: any[]) => void

export const useDebauncedCallback = <F extends Callable>(
    func: F,
    delay = 500
): DebauncedFunction => {
    const timeoutRef = useRef<NodeJS.Timeout>()

    function clearTimer() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = undefined
        }
    }

    return (...args) => {
        clearTimer()

        timeoutRef.current = setTimeout(() => {
            func(...args)
        }, delay)
    }
}
